export default __webpack_public_path__ + "3018c5e8322d8f931129ce19345c23ef.png";